import React from "react";

export default function Circle(props: any){
	let { children, backgroundColor } = props;
	
	const pathProps={
		transform:`translate(26,82) scale(0.95)`,
		d: 'M957.73 453.317C874.182 613.987 650.673 832.498 524.279 948.894C517.718 954.816 509.195 958.093 500.357 958.093C491.519 958.093 482.996 954.816 476.435 948.894C349.327 832.498 125.818 613.987 42.2695 453.317C-141.251 99.8437 321.478 -135.805 500 217.668C678.522 -135.805 1141.25 99.8437 957.73 453.317Z'
	}
	
	return <>
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000">
			<defs>
				<clipPath id="circleView"><path {...pathProps} fill={'black'} /></clipPath>
			</defs>
			<g clipPath="url(#circleView)">
				<path {...pathProps} fill={'none'} stroke={'black'} strokeWidth={'20'} />
				{children}
			</g>
		</svg>
	
	</>
		;
}